/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  RUN_REPORT,
  RUN_REPORT_SUCCESS,
  RUN_REPORT_FAILURE
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  data: null,
  state: "INIT",
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case RUN_REPORT:
      return setLoadingState(state);
    case RUN_REPORT_SUCCESS:
      return setSuccessResponse(state, action);
    case RUN_REPORT_FAILURE:
      return setErrorResponse(state, action.err);
    default:
      return state;
  }
}
